import '@/core/url'
import { renderApp } from './render'

renderApp()
